// extracted by mini-css-extract-plugin
export var cards = "index-module--cards--TNHj1";
export var left = "index-module--left--egk6Z";
export var leftFirst = "index-module--leftFirst--8B1xU";
export var relatedCards = "index-module--relatedCards--ByFTs";
export var removePadding = "index-module--removePadding--GdZDZ";